import styled from 'styled-components';
import { DatePicker } from 'antd';

import { pickerStylesOverride } from './DatePicker';

const RangePicker = styled(DatePicker.RangePicker)`
    ${pickerStylesOverride};

    &.ant-picker-range .ant-picker-active-bar {
        background: ${({ theme }) => theme.colour.primary};
    }
`;

export default RangePicker;
